import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const SaxPixelIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M13.125 27.0312H4.78125V29.8127H13.125V27.0312Z" fill={fillColor || 'black'} />
      <path d="M15.9065 24.25H13.125V27.0315H15.9065V24.25Z" fill={fillColor || 'black'} />
      <path d="M18.6877 21.4688H15.9062V24.2502H18.6877V21.4688Z" fill={fillColor || 'black'} />
      <path d="M4.78147 18.6875H2V27.0312H4.78147V18.6875Z" fill={fillColor || 'black'} />
      <path d="M21.469 13.125H18.6875V21.4687H21.469V13.125Z" fill={fillColor || 'black'} />
      <path d="M7.56272 15.9062H4.78125V18.6877H7.56272V15.9062Z" fill={fillColor || 'black'} />
      <path d="M10.344 13.125H7.5625V15.9065H10.344V13.125Z" fill={fillColor || 'black'} />
      <path d="M18.6875 10.3438H10.3438V13.1252H18.6875V10.3438Z" fill={fillColor || 'black'} />
      <path d="M43.7185 4.78147V2H38.1562V7.56227H46.5V4.78147H43.7185Z" fill={fillColor || 'black'} />
      <path
        d="M29.8127 2V4.78147H27.0312V7.56227H24.2498V15.906H27.0312V13.1252H29.8127V18.6875H24.2498V24.2497H27.0312V21.4689H29.8127V27.0312H24.2498V32.5935H27.0312V29.8127H29.8127V35.3749H24.2498V38.1564H27.0312V40.9372H24.2498V38.1564H21.4689V24.2497H18.6875V27.0312H15.906V29.8127H13.1252V32.5935H10.3438V40.9372H13.1252V43.7187H15.906V46.5001H27.0312V43.7187H29.8127V40.9372H32.5935V7.56227H35.3749V2H29.8127Z"
        fill={fillColor || 'black'}
      />
    </svg>
  );
};

export { SaxPixelIcon };
